import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { Link } from 'react-router-dom';

import "../styles/nomina.css"

type Props = {
  board: {
    ajustes: string;
    bonos: string;
    comisiones: any;
    id: number;
    periodId: number;
    periodo: string;
    statusPeriod: number;
  }[];
  loadingGrid: boolean;
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
};

const CardList: FC<Props> = ({
  board,
  totalRecords,
  pageSize,
  currentPage,
  setCurrentPage,
}) => {
  const [disableNavigation, setDisableNavigation] = useState(true);

  const totalPages = useMemo(
    () => Math.ceil(totalRecords / pageSize),
    [totalRecords, pageSize]
  );
  const pages = useMemo(() => {
    let first = currentPage - 3;
    if (first < 1) first = 0;
    let end = currentPage + 3;
    if (end > totalPages) end = totalPages;
    return Array.from({ length: end - first }, (_, index) => first + index);
  }, [currentPage, totalPages]);

  const [start, end] = useMemo(() => {
    if (currentPage && pageSize) {
      const endTemp = currentPage * pageSize;
      return [
        (currentPage - 1) * pageSize + 1,
        endTemp > totalRecords! ? totalRecords : endTemp,
      ];
    }
    return [0, 0];
  }, [currentPage, pageSize, totalRecords]);

  const showStatusPeriod = (idStatus: number) => {
    if (idStatus === 1) {
      return (
        <>
          <Link
            className="text-info"
            style={{ color: 'blue', cursor: 'pointer' }}
            to="nomina/detalle"
          >
            EN TRAMITE
          </Link>
        </>
      );
    }

    return (
      <span className="card-text" style={{ color: 'red', cursor: 'default' }}>
        FINALIZADO
      </span>
    );
  };

  const handleFirst = () => {
    setDisableNavigation(true);
    setCurrentPage(1);
  };
  const handlePrev = () => {
    setDisableNavigation(true);
    setCurrentPage!((prev) => prev - 1);
  };
  const handleNext = () => {
    setDisableNavigation(true);
    setCurrentPage!((prev) => prev + 1);
  };
  const handleLast = () => {
    setDisableNavigation(true);
    const finalPage = Math.ceil(totalRecords! / pageSize!);
    setCurrentPage!(finalPage);
  };

  useEffect(() => {
    setDisableNavigation(false);
  }, [board]);

  return (
    <div className="container mt-5">
      <section>
        <div className="row">
          {board.map((item, index) => (
            <div
            key={index}
            className="col-md-6 col-lg-4 col-xxl-4 col-xl-4 mb-4 mt-4"
            onClick={() => console.log('Este es el periodo:', item.periodo)}
            >
              <div className="card border cursor-pointer">
                <div className="card-body">
                  <h5 className="card-title">{item.periodo}</h5>
                  <div className='mb-2 d-flex align-items-center'>
                    <input style={{ width: "1.2rem", height: "1.2rem", borderRadius:"10px" }} 
                    className="form-check-input opacity-100 no-img-checkbox" 
                    type="checkbox" name="flexRadioDefault" id="flexRadioDefault1" 
                    checked={item.ajustes === "true"} disabled />
                    <label className='ms-2'>Ajustes</label>
                  </div>
                  <div className='mb-2 d-flex align-items-center'>
                    <input style={{ width: "1.2rem", height: "1.2rem", borderRadius:"10px" }} 
                    className="form-check-input opacity-100 no-img-checkbox" 
                    type="checkbox" name="flexRadioDefault" id="flexRadioDefault2" 
                    checked={item.bonos === "true"} disabled />
                    <label className='ms-2'>Bonos</label>
                  </div>
                  <div className='mb-2 d-flex align-items-center'>
                    <input style={{ width: "1.2rem", height: "1.2rem", borderRadius:"10px" }}
                      className="form-check-input opacity-100 no-img-checkbox"
                      type="checkbox" name="flexRadioDefault" id="flexRadioDefault3"
                      checked={item.comisiones === "true"} disabled />
                    <label className='ms-2'>Comisiones</label>
                  </div>
                  {showStatusPeriod(item.statusPeriod)}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Paginación xdddddddddd */}
        <div className="row justify-content-center">
          <nav aria-label="Navegación de página">
            <ul className="pagination">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handleFirst}
                  disabled={currentPage === 1 || disableNavigation}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="grey"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                    <path fill="none" d="M24 24H0V0h24v24z"></path>
                  </svg>
                </button>
              </li>
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handlePrev}
                  disabled={currentPage === 1 || disableNavigation}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="grey"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
              </li>
              {pages[0] !== 0 && (
                <li className="page-item">
                  <div className="page-dot-dot-dot">...</div>
                </li>
              )}
              {pages.map((i) => (
                <li
                  key={i}
                  className={`page-item ${currentPage === i + 1 ? 'active' : ''
                    }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(i + 1)}
                    disabled={disableNavigation}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
              {pages[pages.length - 1] !== totalPages - 1 && (
                <li className="page-item">
                  <div className="page-dot-dot-dot">...</div>
                </li>
              )}
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handleNext}
                  disabled={end === totalRecords || disableNavigation}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="grey"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
              </li>
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handleLast}
                  disabled={end === totalRecords || disableNavigation}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="grey"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                  </svg>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </section>
    </div>
  );
};

export { CardList };
